var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFullscreenIcon = function SvgFullscreenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    viewBox: "0 0 448 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 180V56c0-13 11-24 24-24h124c7 0 12 5 12 12v40c0 7-5 12-12 12H64v84c0 7-5 12-12 12H12c-7 0-12-5-12-12zM288 44v40c0 7 5 12 12 12h84v84c0 7 5 12 12 12h40c7 0 12-5 12-12V56c0-13-11-24-24-24H300c-7 0-12 5-12 12zm148 276h-40c-7 0-12 5-12 12v84h-84c-7 0-12 5-12 12v40c0 7 5 12 12 12h124c13 0 24-11 24-24V332c0-7-5-12-12-12zM160 468v-40c0-7-5-12-12-12H64v-84c0-7-5-12-12-12H12c-7 0-12 5-12 12v124c0 13 11 24 24 24h124c7 0 12-5 12-12z"
  })));
};

export default SvgFullscreenIcon;